import { useState } from "react";
import { snackbarStart } from "../../store/SnackbarSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const GeneratePinfl = () => {
  const [quantity, setQuantity] = useState(0);
  const [pinflData, setPinflData] = useState([]);
  const [btnDisable, setBtnDisable] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const getPinfl = () => {
    let firstNum = getRandomInt(1, 9);
    let day = getRandomInt(1, 30);
    let month = getRandomInt(1, 12);
    let year = getRandomInt(1, 99);
    let lastNum = getRandomInt(1000000, 9999999);
    if (day.toString().length === 1) {
      day = `0${day}`;
    }
    if (month.toString().length === 1) {
      month = `0${month}`;
    }
    if (year.toString().length === 1) {
      year = `0${year}`;
    }
    return `${firstNum}${day}${month}${year}${lastNum}`;
  };

  const handleClick = () => {
    if (!quantity) return;
    for (let i = 0; i < quantity; i++) {
      let pinfl = getPinfl();
      if (pinflData.includes(pinfl)) {
        i--;
      } else setPinflData((prevArray) => [...prevArray, pinfl]);
    }
    setBtnDisable(true);
  };

  const reset = () => {
    setPinflData([]);
    setBtnDisable(false);
    setQuantity(0);
  };

  return (
    <div className="pt-20 min-h-screen bg-gray-50 dark:bg-[#030712] text-slate-800 dark:text-slate-100 transition-colors duration-300">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header Section */}
        <div className="text-center mb-10">
          <div className="inline-flex justify-center items-center w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg shadow-blue-500/30 mb-6">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>
          <h1 className="text-3xl font-bold mb-4">
            {t("generatePinfl.title")}
          </h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 max-w-2xl mx-auto">
            {t("generatePinfl.description")}
          </p>
        </div>

        {/* Control Panel */}
        <div className="bg-white dark:bg-[#0f172a] rounded-2xl border border-slate-200 dark:border-slate-800 p-8 mb-8 shadow-sm">
          <div className="flex flex-col sm:flex-row items-end justify-center gap-6">
            <div className="flex flex-col items-start w-full sm:w-auto max-w-[150px] mx-auto sm:mx-0">
              <label
                htmlFor="quantity"
                className="text-sm font-medium text-slate-600 dark:text-slate-400 mb-2"
              >
                {t("generatePinfl.quantityLabel")}
              </label>
              <input
                id="quantity"
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                className="w-32 px-4 py-3 text-center bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-lg font-semibold text-slate-900 dark:text-slate-100 outline-none"
                placeholder={t("generatePinfl.quantityPlaceholder")}
                min="1"
                max="1000"
              />
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mt-4 sm:mt-0">
              <button
                onClick={handleClick}
                disabled={btnDisable}
                className={`flex-1 sm:flex-none px-8 py-3 rounded-lg font-semibold text-white transition-all duration-200 text-sm ${
                  btnDisable
                    ? "bg-slate-300 dark:bg-slate-800 text-slate-500 dark:text-slate-600 cursor-not-allowed"
                    : "bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 shadow-md hover:shadow-lg shadow-blue-500/20"
                }`}
              >
                {btnDisable
                  ? t("generatePinfl.generatedBtn")
                  : t("generatePinfl.startBtn")}
              </button>

              <button
                onClick={reset}
                className="flex-1 sm:flex-none px-8 py-3 rounded-lg font-semibold text-rose-600 dark:text-rose-400 bg-rose-50 dark:bg-rose-500/10 hover:bg-rose-100 dark:hover:bg-rose-500/20 border border-rose-200 dark:border-rose-500/20 transition-all duration-200 text-sm"
              >
                {t("generatePinfl.resetBtn")}
              </button>
            </div>
          </div>
        </div>

        {/* Results Section */}
        {pinflData.length > 0 && (
          <div className="bg-white dark:bg-[#0f172a] rounded-2xl border border-slate-200 dark:border-slate-800 p-8 shadow-sm animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="text-center mb-6">
              <h2 className="text-xl font-bold mb-3">
                {t("generatePinfl.resultsTitle")}
              </h2>
              <div className="inline-flex items-center px-3 py-1 bg-green-50 dark:bg-green-500/10 text-green-600 dark:text-green-400 border border-green-200 dark:border-green-500/20 rounded-full text-xs font-medium">
                <svg
                  className="w-3.5 h-3.5 mr-1.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                {pinflData.length} {t("generatePinfl.recordsGenerated")}
              </div>
            </div>

            <div className="max-h-96 overflow-y-auto border border-slate-200 dark:border-slate-800 rounded-xl custom-scrollbar">
              <ol className="divide-y divide-slate-100 dark:divide-slate-800/50">
                {pinflData?.map((item, index) => (
                  <li
                    key={item}
                    className="px-6 py-4 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors duration-150 flex items-center justify-between group"
                  >
                    <div className="flex items-center">
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-full text-xs font-medium mr-4">
                        {index + 1}
                      </span>
                      <span className="font-mono text-lg tracking-wider text-slate-800 dark:text-slate-200 font-medium">
                        {item}
                      </span>
                    </div>
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(item);
                        dispatch(
                          snackbarStart({
                            text: t("generatePinfl.copiedToClipboard", {
                              item,
                            }),
                            severity: "success",
                          }),
                        );
                      }}
                      className="text-slate-400 hover:text-blue-500 dark:hover:text-blue-400 opacity-0 group-hover:opacity-100 transition-all duration-200 p-2 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-500/10"
                      title="Copy to clipboard"
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                        />
                      </svg>
                    </button>
                  </li>
                ))}
              </ol>
            </div>

            <div className="mt-8 text-center">
              <button
                onClick={() => {
                  const allNumbers = pinflData.join("\n");
                  navigator.clipboard.writeText(allNumbers);
                  dispatch(
                    snackbarStart({
                      text: t("generatePinfl.allCopiedMsg", {
                        count: pinflData.length,
                      }),
                      severity: "success",
                    }),
                  );
                }}
                className="inline-flex items-center px-6 py-2.5 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-lg transition-colors duration-200 text-sm font-semibold border border-slate-200 dark:border-slate-700 shadow-sm"
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
                {t("generatePinfl.copyAllBtn")}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneratePinfl;
